
define(function (require) {

  var JsonPollock = require('jsonPollock');

  var StructuredContentManager = function () {
      //TODO: do we need that?
        var that = this;
  };

  StructuredContentManager.prototype.render = function (json) {
    var retObj= {
      error: null,
      domEL: null
    };

    if (json) {
      try {
        if(_.isString(json)){
          json = JSON.parse(json);
        }
        var domEL = JsonPollock.render(json);
        if(domEL) {
          //disable ui gestures for actionable elements
          _.each(domEL.querySelectorAll('*'), function(el){
            if(_.isFunction(el.onclick) &&  el.className.indexOf('lp-json-pollock-component-action') === -1) {
              el.disabled = true;
            }
          });
        }
        retObj.domEL = domEL;
      } catch (e) {
        retObj.error = e;
      }
    }

    return retObj;
  };

  return new StructuredContentManager();

});
